import { useIsClient } from "src/hooks/useIsClient"
import { createPersistentStore } from "src/utilities/localStorage/create"

type State = Record<string, string>

const defaultState: State = {}

const store = createPersistentStore(() => defaultState, {
  name: "selectedVariationByProductId",
})

export function setSelectedSkuBySlug(slug: string, sku: string) {
  store.setState({ [slug]: sku })
}

export function useSelectedSkuBySlug(slug: string, defaultSku: string | undefined) {
  const isClient = useIsClient()
  const selectedSku = store((state) => state[slug])

  if (!isClient || !selectedSku) {
    return defaultSku
  }

  return selectedSku
}
